import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationComponent } from './pages/authentication/authentication.component';
import { TestComponent } from './test/test.component';
import { AuthGuard } from './pages/authentication/guards/auth.guard';

const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('../app/pages/pages.module')
      .then(m => m.PagesModule)
  },
  {
    path: '**',
    loadChildren: () => import('../app/pages/pages.module')
      .then(m => m.PagesModule), canActivate:[AuthGuard]
  },
  {
    path:'test',
    component:TestComponent
  },
  { path: 'vendorremark', loadChildren: () => import('./pages/vendorremark/vendorremark.module').then(m => m.VendorremarkModule) },
  
];

@NgModule({
  // imports: [RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' , useHash: true })],
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
